import { useEffect, useState, useRef, useCallback } from "react";
import HeaderPageBrad from "../../components/ComponentsPageBrad/HeaderPageBrad";
import InputSection from "../Dashboard/ConversationUser/ChatInputSection/InputSection";
import { useRedux } from "../../hooks";
import { useChatStore } from "../../state/chat";
import useChatWebSocket from "../../hooks/useChatWebSocket";
import { nanoid } from "nanoid";
import { showErrorNotification, showSuccessNotification, showWarningNotification } from "../../helpers/notifications";
import sendButtonDark from "../../assets/images/icons/sendMessageDark.svg";
import sendButtonLight from "../../assets/images/icons/sendMessageLigth.svg";
import iconPdfDark from "../../assets/images/icons/iconPdfDark.svg";
import dotsIcon from "../../assets/images/icons/dots.svg";
import iconMicroDark from "../../assets/images/icons/iconMicroDark.svg";
import planUploadedIcon from "../../assets/images/icons/Plan-uploaded.svg";

import { getBearerToken } from "../../helpers/localStorageHelpers";
import Conversation from "../Dashboard/ConversationUser/Conversation";
import { getUserChats } from "../../api";
import { useNavigate } from "react-router-dom";
import getThemeFilter from "../../utils/micColor";
import { IMessage } from "../../@DTO/chat";
import getThemeColors from "../../utils/getColorTheme";
import { useTheme } from "../../contexts/ThemeContext";
import { getPredefinedResponses, trackPredefinedResponseWithAnalytics } from "../../utils/predefinedResponses";
import { WEB_LOGIN_PATH } from "../../routes/authPaths";
import axios from "axios";
import { Modal } from "../../components/Modal";
import { toast } from "sonner";
import { MenuModal } from '../../components/MenuModal';
import { SimpleModal } from "../../components/SimpleModal";
import useAnalytics from "../../hooks/useAnalytics";
import { useSession, useSupabaseClient, useUser } from "@supabase/auth-helpers-react";
import closeIcon from "../../assets/images/icons/iconClose.svg";
import * as planUploadApi from '../../api/planUpload';
import { jsPDF } from 'jspdf';

import gif1 from "../../assets/images/gif/9tmtwr.gif";
import gif2 from "../../assets/images/gif/9tmtrs.gif";
import gif3 from "../../assets/images/gif/9tmtir.gif";
import gif4 from "../../assets/images/gif/9tmtgk.gif";
import gif5 from "../../assets/images/gif/9tmteu.gif";
import gif6 from "../../assets/images/gif/9tmqmp.gif";
import gif7 from "../../assets/images/gif/9tmqlb.gif";



const getRandomGif = () => {
  const gifs = [gif1, gif2, gif3, gif4, gif5, gif6, gif7];
  const randomIndex = Math.floor(Math.random() * gifs.length);
  return gifs[randomIndex];
};

const getWelcomeMessages = () => {
  return [
    {
      type: "ai",
      data: {
        content:
          "Hi there, I'm FAM, your AI powered care companion.\n\n" +
          "Whether you're caring for a child, planning your own support, helping someone you love or delivering care yourself, I'm here to guide you through Australia's care systems.\n\n" +
          "Care isn't just forms and funding, it's personal. That's why I was created for the everyday moments, from big wins to quiet worries.\n\n" +
          "For All Milestones (FAM).",
        tool_calls: [],
        invalid_tool_calls: [],
        additional_kwargs: {},
        response_metadata: {},
      },
    },
    {
      type: "ai",
      data: {
        content:
          "You can start chatting as a guest or log in so I can remember your preferences, pick up where you left off and tailor support to you.\n\n" +
          "Would you like to continue as a guest or log in?",
        tool_calls: [],
        invalid_tool_calls: [],
        additional_kwargs: {},
        response_metadata: {},
      },
    },
  ];
};

const getDefaultMessages = () => {
  if (!(process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true')) {
    return getWelcomeMessages();
  }
  

  const randomGif = getRandomGif();
  return [
    {
      type: "ai",
      data: {
        content: `![Welcome gif](${randomGif})\n\n**Show this to get a free coffee!**`,
        tool_calls: [],
        invalid_tool_calls: [],
        additional_kwargs: {},
        response_metadata: {},
      },
    },
  ];
};

const getAdditionalWelcomeMessages = () => {
  return getWelcomeMessages();
};

export function HomePage({ selectedChat }: any) {
  const { addTheme, setAddTheme } = useTheme();
  const { messages, setMessages, setNewMessage, isReceivingMessage, reset } = useChatStore();
  const { trackPlanUploadClick, trackPlanUploadSuccess } = useAnalytics();
  const [stopRecording, setStopRecording] = useState(false);
  const [message, setMessage] = useState("");
  const [quickOptions, setQuickOptions] = useState<string[]>([]);
  const [showInput, setShowInput] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPopupMenu, setShowPopupMenu] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showUploadingModal, setShowUploadingModal] = useState(false);
  const [modalVariant, setModalVariant] = useState<'loading' | 'success' | 'warning' | 'error'>('loading');
  const [modalMessage, setModalMessage] = useState<string>('');
  const [messageDefault] = useState(getDefaultMessages());

  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [pdfFileName, setPdfFileName] = useState<string>("");
  const [processingPdf, setProcessingPdf] = useState(false);
  const [updatingPrompt, setUpdatingPrompt] = useState(false);
  const [flowiseFlowId, setFlowiseFlowId] = useState<string>("");
  const [isProcessingChunks, setIsProcessingChunks] = useState(false);
  const [hasInjectedPdf, setHasInjectedPdf] = useState(false);
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [showNotificationDot, setShowNotificationDot] = useState(true);
  
  // Add state for mobile detection with localStorage
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileSmall, setIsMobileSmall] = useState(false);
  const [layoutReady, setLayoutReady] = useState(false);
  
  // File input reference
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Create refs for popup menu click outside detection
  const menuRef = useRef<HTMLDivElement | null>(null);
  const dotsButtonRef = useRef<HTMLButtonElement | null>(null);
  
  // Add a ref to track resize timeout
  const resizeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Initialize hasShownWelcomeMessages to true if we're not displaying the welcome GIF
  const [hasShownWelcomeMessages, setHasShownWelcomeMessages] = useState(!(process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true'));

  // Add this state for the checkbox
  const [consentChecked, setConsentChecked] = useState(false);
  const [savingConsent, setSavingConsent] = useState(false);

  // Add this state to track if the user has already given consent
  const [hasExistingConsent, setHasExistingConsent] = useState(false);

  // Add Supabase client and user
  const supabaseClient = useSupabaseClient();
  const user = useUser();
  
  // Track authentication state
  const [previousUser, setPreviousUser] = useState(user);
  const [hasInitialized, setHasInitialized] = useState(false);

  // Generate anon token once per session (refreshes on page reload)
  const [anonToken] = useState(() => nanoid());

  // Add useEffect for mobile detection with localStorage
  useEffect(() => {
    const handleResize = () => {
      // Clear existing timeout
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }

      // Set layout as not ready during resize
      setLayoutReady(false);

      // Debounce the resize handling
      resizeTimeoutRef.current = setTimeout(() => {
        const mobile = window.innerWidth <= 992;
        const mobileSmall = window.innerWidth <= 480;
        
        setIsMobile(mobile);
        setIsMobileSmall(mobileSmall);
        
        // Store in localStorage for persistence
        localStorage.setItem('isMobile', mobile.toString());
        localStorage.setItem('isMobileSmall', mobileSmall.toString());
        
        // Set layout as ready after state updates
        setTimeout(() => {
          setLayoutReady(true);
        }, 50);
      }, 150); // Debounce delay
    };

    // Initial setup
    const storedIsMobile = localStorage.getItem('isMobile');
    const storedIsMobileSmall = localStorage.getItem('isMobileSmall');
    
    if (storedIsMobile !== null && storedIsMobileSmall !== null) {
      setIsMobile(storedIsMobile === 'true');
      setIsMobileSmall(storedIsMobileSmall === 'true');
    } else {
      const mobile = window.innerWidth <= 992;
      const mobileSmall = window.innerWidth <= 480;
      setIsMobile(mobile);
      setIsMobileSmall(mobileSmall);
      localStorage.setItem('isMobile', mobile.toString());
      localStorage.setItem('isMobileSmall', mobileSmall.toString());
    }

    // Set initial layout ready state
    setTimeout(() => {
      setLayoutReady(true);
    }, 100);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, []);

  // Verify Supabase connection on component mount
  useEffect(() => {
    const checkSupabaseConnection = async () => {
      if (!supabaseClient) {
        console.error("Supabase client is not initialized");
        return;
      }
      
      // Check if user is logged in before making Supabase calls
      const token = JSON.parse(localStorage.getItem("sb-auth-token") || "null")?.access_token;
      if (!token) {
        console.log("User not logged in, skipping Supabase user data fetch");
        return;
      }
      
      try {
        const { data, error } = await supabaseClient.auth.getUser();
        if (error) {
          console.error("Error getting current user:", error);
        } else {          
          // If user is logged in, check the user's record
          if (data?.user?.id) {
            const { data: userData, error: userError } = await supabaseClient
              .from("users")
              .select("*")
              .eq("id", data.user.id)
              .single();
              
            if (userError) {
              console.error("Error fetching user data:", userError);
            } else {
              
              // Check if user already has consent saved
              if (userData.ndis_plan_consent === true) {
                setHasExistingConsent(true);
              }
            }
          }
        }
      } catch (err) {
        console.error("Failed to verify Supabase connection:", err);
      }
    };
    
    checkSupabaseConnection();
  }, [supabaseClient]);

  const handleQuickOptionClick = (option: string) => {
    // Prevent clicking on quick options if PDF is being processed
    if (processingPdf || updatingPrompt || isProcessingChunks || isReceivingMessage) {
      return;
    }
    
    // Special handling for "Log In for Personalised Support" option
    if (option === "Log In for Personalised Support") {
      // Track the predefined response with enhanced analytics before navigating
      if (messages.length > 0) {
        const lastMessage = messages[messages.length - 1]?.data?.content;
        trackPredefinedResponseWithAnalytics(lastMessage || "Unknown question", option);
      } else if (messageDefault.length > 0) {
        const messageToTrack = !(process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true') && messageDefault.length > 1
          ? messageDefault[1].data.content 
          : messageDefault[0].data.content;
          
        trackPredefinedResponseWithAnalytics(messageToTrack, option);
      }
      
      // Navigate to login page
      navigate(WEB_LOGIN_PATH);
      return;
    }
    
    // Special handling for "I'm ready to chat" option, only when welcome GIF is enabled
    if ((process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true') && option === "I'm ready to chat" && !hasShownWelcomeMessages) {
      // Get the additional welcome messages
      const additionalMessages = getAdditionalWelcomeMessages();
      
      // Create a new array with all messages to update state
      const updatedMessages = [...messages, ...additionalMessages];
      setMessages(updatedMessages);
      
      // Mark that we've shown the welcome messages
      setHasShownWelcomeMessages(true);
      
      return;
    }
    
    // Track the predefined response with enhanced analytics
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]?.data?.content;
      trackPredefinedResponseWithAnalytics(lastMessage || "Unknown question", option);
    } else if (messageDefault.length > 0) {
      // For the case where welcome GIF is skipped, track from the appropriate message
      const messageToTrack = !(process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true') && messageDefault.length > 1
        ? messageDefault[1].data.content 
        : messageDefault[0].data.content;
        
      trackPredefinedResponseWithAnalytics(messageToTrack, option);
    }
    
    setMessage(""); 
    onSend({ text: option }); 
    setQuickOptions([]);
    setShowInput(false); 
  };

  const [selectedChatOption, setSelectedChatOption] = useState<
    "CHAT" | "IMAGE"
  >("CHAT");
  const [isDefaultChat, setIsDefaultChat] = useState(messages.length === 0);
  const [quickMessage, setQuickMessage] = useState("");

  const navigate = useNavigate();
  const { theme, background } = getThemeColors(addTheme);

  const { useAppSelector } = useRedux();
  const { assistant } = useAppSelector(state => ({
    assistant: state.Chats.assistant,
  }));

  function onChangeText(value: string) {
    setMessage(value);
  }
  const { sendWebsocketMessage, closeWebSocket } = useChatWebSocket();

  const session = useSession();

  const [isAndroid, setIsAndroid] = useState(false);
  
  // Detect Android device when component mounts
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroidDevice = /android/.test(userAgent);
    setIsAndroid(isAndroidDevice);
  }, []);

  const onSend = (data: any) => {
    try {
      const jwt = getBearerToken();

      const message = {
        query: data.text,
        jwt: jwt,
        anon_token: anonToken
      }

      const messageData: IMessage = {
        type: "human",
        data: {
          content: data.text,
          additional_kwargs: {},
          response_metadata: {},
        },
      };
      setNewMessage(messageData);

      sendWebsocketMessage(JSON.stringify(message));
    } catch (error: any) {
      showWarningNotification(error);
    }
  };

  function onStop() {
    console.log(`close websocket`);
    closeWebSocket();
    reset();
  }



  function onSubmit() {
    if (!message) {
      return;
    }

    // Prevent sending messages if PDF is being processed
    if (processingPdf || updatingPrompt || isProcessingChunks || isReceivingMessage) {
      return;
    }

    let messageText = "";

    if (!message.includes("/create")) {
      messageText =
        selectedChatOption === "IMAGE" ? `/create ${message}` : message;
    } else {
      messageText = message;
    }

    onSend({ text: messageText });

    setMessage("");
  }

  // Clear messages and cleanup when component unmounts (navigation away) - only for non-logged users
  useEffect(() => {
    return () => {
      // Only clear messages if user is not logged in
      const token = JSON.parse(localStorage.getItem("sb-auth-token") || "null")?.access_token;
      if (!token || !user) {
        console.log("User not logged in, clearing messages on navigation");
        setMessages([]);
        reset();
      } else {
        console.log("User logged in, keeping messages for next visit");
      }
    };
  }, [setMessages, reset, user]);

  // Define the function to fetch chat history
  const getHistoryChats = useCallback(async () => {
    try {
      // Check if user is logged in before fetching chats
      const token = JSON.parse(localStorage.getItem("sb-auth-token") || "null")?.access_token;
      if (!token || !user) {
        console.log("User not logged in, starting fresh");
        setMessages([]);
        return;
      }
      
      const response = await getUserChats();
      const messages = response.messages;
      if (Array.isArray(messages) && messages.length > 0) {
        setMessages(messages);
      } else {
        setMessages([]);
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
      setMessages([]);
    }
  }, [user, setMessages]);

  // Handle authentication state changes
  useEffect(() => {
    const currentUserId = user?.id;
    const previousUserId = previousUser?.id;
    
    // If user logged out (had user, now no user)
    if (previousUserId && !currentUserId && hasInitialized) {
      console.log("User logged out, clearing messages");
      setMessages([]);
      reset();
    }
    
    // If user logged in (no user, now has user) or changed user
    if (currentUserId && (currentUserId !== previousUserId) && hasInitialized) {
      console.log("User changed, reloading messages");
      setMessages([]);
      reset();
      // Fetch messages for the new user
      getHistoryChats();
    }
    
    // Update previous user reference
    setPreviousUser(user);
  }, [user, previousUser, hasInitialized, setMessages, reset, getHistoryChats]);

  // Initialize messages on component mount
  useEffect(() => {
    // Only fetch on initial mount, not on every render
    if (!hasInitialized) {
      getHistoryChats().finally(() => setHasInitialized(true));
    }
  }, [hasInitialized, getHistoryChats]);

    useEffect(() => {
    if (isProcessingChunks) {
      // Don't update quick options while processing chunks
      return;
    }
    
    // If we're showing just the welcome GIF message, display the "I'm ready to chat" option
    if ((process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true') && messages.length === 0 && !hasShownWelcomeMessages) {
      setQuickOptions(["I'm ready to chat"]);
      setShowInput(false);
      return;
    }
    
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]?.data?.content;
      const predefinedResponses = getPredefinedResponses(lastMessage);

      if (predefinedResponses.length > 0) {
        setQuickOptions(predefinedResponses);
        setShowInput(false);
        // Don't hide plan upload banner anymore - keep it visible regardless of predefined responses
      } else {
        setQuickOptions([]); 
        setShowInput(true);
      }
    } else {
      // Only check messageDefault if we have messages to check
      if (messageDefault.length > 0) {
        // For the case where welcome GIF is skipped, check the second message
        // which would be the "quick questions" message
        const messageToCheck = !(process.env.REACT_APP_DISPLAY_WELCOME_GIF === 'true') && messageDefault.length > 1 
          ? messageDefault[1].data.content 
          : messageDefault[0].data.content;
          
        const predefinedResponses = getPredefinedResponses(messageToCheck);
        
        if (predefinedResponses.length > 0) {
          setQuickOptions(predefinedResponses);
          setShowInput(false); 
        } else {
          setQuickOptions([]);
          setShowInput(true);
        }
      } else {
        setQuickOptions([]);
        setShowInput(true);
      }
    }
  }, [messages, isProcessingChunks, hasShownWelcomeMessages, messageDefault, hasInjectedPdf]);

  const [showPIIModal, setShowPIIModal] = useState(false);
  const [detectedPII, setDetectedPII] = useState<Array<[string, string]>>([]);
  const [processedText, setProcessedText] = useState("");
  const [documentVersion, setDocumentVersion] = useState("unknown");
  const [uploadError, setUploadError] = useState<string | null>(null);
  
  const handlePdfUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    
    if (file.type !== "application/pdf") {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const response = await planUploadApi.getPresignedUrl();
    const url = response.url;

    console.log(`url: ${url}`);

    try {
      // Upload file to S3
      const s3 = axios.create({
        headers: { common: {} },
        transformRequest: (data) => data, 
      });
      await s3.put(
        url,
        file,
        {
          headers: {
            "Content-Type": "application/pdf"
          }
        }
      );
      console.log(`file uploaded!`);
    } catch (error: any) {
      console.error('Error uploading file:', error);
      console.log(`status: ${error.response?.status}`);
      console.log(`data: ${error.response?.data}`);
      if (error instanceof Error) {
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
      }
      throw error;
    }
    
    setPdfFile(file);
    setPdfFileName(file.name);
    setProcessingPdf(true);
    // // Don't show the privacy modal yet - only after successful processing
    
    // // Show uploading modal
    setModalVariant('loading');
    setModalMessage('Uploading your plan');
    setShowUploadingModal(true);
    setUploadError(null);

    // Process the pdf
    console.log(`processing plan`);
    planUploadApi.processPlan()
      .then((response) => {
        console.log(`response: ${response}`);
        setProcessedText(response.processed_text || "");
        setDetectedPII(response.detected_pii || []);
        setDocumentVersion(response.version || "unknown");

        if (response.processed_text === 'This is an unknown version #$@FAM#$@') {
          return "This is an unknown version #$@FAM#$@";
        }
        
        const criticalPII = {
          participant_name: false,
          participant_ndis_number: false,
          address: false
        };

        response.detected_pii.forEach((item: [string, string]) => {
          const [field, value] = item;
          if (field in criticalPII && value && value.trim() !== "" && value.toLowerCase() !== "none") {
            criticalPII[field as keyof typeof criticalPII] = true;
          }
        });

        if (!criticalPII.participant_name || !criticalPII.participant_ndis_number || !criticalPII.address) {
          setShowUploadingModal(false);
          setShowPIIModal(true);
          
          // We don't track success/failure yet as the user needs to verify PII
          
          return null; // Don't continue with masking yet
        }

        return planUploadApi.applyMasking(response.processed_text, response.detected_pii, response.version);
      })
      .then(async (maskResponse: any) => {
        // If we're showing the PII modal, don't continue processing
        if (showPIIModal || maskResponse === null) {
          return null;
        }
        

        if (maskResponse === 'This is an unknown version #$@FAM#$@') {
          setModalVariant('error');
          setModalMessage("This file doesn't look like an NDIS plan. Please upload your official NDIS plan PDF so we can assist you accurately.");
          setUploadError("This file doesn't look like an NDIS plan. Please upload your official NDIS plan PDF so we can assist you accurately.");
          const pdfClearedTimestamp = localStorage.getItem('pdf_cleared_timestamp') || '0';
          planUploadApi.deletePlan()
            .then(success => {
              console.log("Delete NDIS plan result:", success);
              localStorage.setItem('last_reset_timestamp', pdfClearedTimestamp);
              localStorage.removeItem('pdf_data_cleared');
            })
            .catch(error => {
              console.error("Error deleting NDIS plan:", error);
            });
          return;
        }

        // Handle possible response formats
        if (!maskResponse) {
          throw new Error("Error masking PDF: Empty response from server");
        }
        
        // Get the response data
        const responseData = maskResponse.data || maskResponse;
        
        // Extract masked text
        let maskedText = '';
        if (typeof responseData.masked_text === 'string') {
          maskedText = responseData.masked_text;
        } else {
          console.error("Unexpected mask response structure:", responseData);
          throw new Error("Could not find masked text in response");
        }
        
        // If we somehow still got empty text even after finding the right property
        if (maskedText.trim().length === 0) {
          throw new Error("The PDF was processed but produced empty text");
        }
        
        // Extract relevant data from the response
        const result = {
          originalFileName: responseData.file_name || file.name,
          sanitizedText: maskedText,
          piiCount: Array.isArray(responseData.detected_pii) ? responseData.detected_pii.length : 0,
          version: responseData.version || 'unknown'
        };
        
        // Store sanitized text in MongoDB
        setIsProcessingChunks(true);
        
        const s3Response = await planUploadApi.getPresignedUrl();
        const s3Url = s3Response.url;
        
        // Convert sanitized text to PDF
        const doc = new jsPDF();
        doc.text(result.sanitizedText, 10, 10);
        const pdfBlob = doc.output('blob');

        // Upload processed file to S3
        const s3 = axios.create({
          headers: { common: {} },
          transformRequest: (data) => data, 
        });
        
        try {
          // This will overwrite the raw plan
          await s3.put(
            s3Url,
            pdfBlob,
            {
              headers: {
                "Content-Type": "application/pdf"
              },
              validateStatus: () => true
            }
          );
          console.log(`file uploaded!`);
          setHasInjectedPdf(true);
          return "OK";
        } catch (error: any) {
          console.error('Error uploading file:', error);
          console.log(`status: ${error.response?.status}`);
          console.log(`data: ${error.response?.data}`);
          if (error instanceof Error) {
            console.error('Error message:', error.message);
            console.error('Error stack:', error.stack);
          }
          throw error;
        }
      })
      .then(success => {
        // Skip if there was an error or undefined (waiting for user input)
        if (success === undefined || success === null) return;
        
        // Send success message through websocket with file info
        const fileName = file?.name || "document.pdf";
        const successMessage = `<div style="display: flex; align-items: flex-start; gap: 0.5em;"><img src="${planUploadedIcon}" alt="Plan uploaded" style="width: 1.5em; height: 1.5em; flex-shrink: 0; margin-top: 0.1em;" /><div style="text-align: left;"><div>Plan uploaded successfully</div><div style="color: #999999; font-size: 0.8em; margin-top: 0.25em;">${fileName}</div></div></div>`;
        onSend({ text: successMessage });
        
        // Show success modal
        setModalVariant('success');
        setModalMessage('PDF processed successfully!');
        // Keep the modal open for a moment to show success
        setTimeout(() => {
          setShowUploadingModal(false);
          // Now show the privacy modal after successful processing
          setShowModal(true);
          setConsentChecked(false);
        }, 2000);
        
        // Enable input and set PDF injected flag
        setShowInput(true);
        setHasInjectedPdf(true);
        
        // Track successful PDF upload
        trackPlanUploadSuccess(true);
      })
      .catch(error => {
        console.error("PDF processing error:", error);
        
        // Try to determine the type of error for better user feedback
        let errorMessage = "Error processing PDF. Please try a different file.";
        let errorType = 'general_error';
        
        if (error.message) {
          if (error.message.includes("No response") || error.message.includes("Network")) {
            errorMessage = "Connection error. Please check your internet connection and try again.";
            errorType = 'network_error';
          } else if (error.message.includes("empty") || error.message.includes("could not be processed")) {
            errorMessage = "The PDF could not be processed. It may be empty, password-protected, or in an unsupported format.";
            errorType = 'format_error';
          } else if (error.message.includes("masked")) {
            errorMessage = "Could not sanitize sensitive information in the PDF. Using original text might expose private data.";
            errorType = 'masking_error';
          } else {
            // Keep the original error message if it's informative
            errorMessage = error.message;
          }
        }
        
        // Set error modal
        setModalVariant('error');
        setModalMessage(errorMessage);
        setUploadError(errorMessage);
        
        // Track failed PDF upload with error type
        trackPlanUploadSuccess(false, errorType);
      })
      .finally(() => {
        if (!showPIIModal) {
          // Make sure all processing states are reset if we're not showing the PII modal
          setProcessingPdf(false);
          setIsProcessingChunks(false);
          setUpdatingPrompt(false);
        }
        // Reset the file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      });
  };

  const handlePdfButtonClick = () => {
    // Prevent clicking PDF button if already processing
    if (processingPdf || updatingPrompt || isProcessingChunks || isReceivingMessage) {
      return;
    }
    
    // Track the PDF upload button click
    trackPlanUploadClick();
    
    fileInputRef.current?.click();
  };

  // Listen for PDF data reset events
  useEffect(() => {    
    const handleStorageChange = (event) => {
      if (event.key === 'pdf_data_cleared' && event.newValue === 'true') {
        const pdfClearedTimestamp = localStorage.getItem('pdf_cleared_timestamp') || '0';
        const lastResetTimestamp = localStorage.getItem('last_reset_timestamp') || '0';
        
        // Only proceed if this is a new clear request
        if (parseInt(pdfClearedTimestamp) > parseInt(lastResetTimestamp)) {
          console.log("PDF data cleared from another tab, deleting NDIS plan...");
          
          planUploadApi.deletePlan()
            .then(success => {
              console.log("Delete NDIS plan result:", success);
              localStorage.setItem('last_reset_timestamp', pdfClearedTimestamp);
              localStorage.removeItem('pdf_data_cleared');
            })
            .catch(error => {
              console.error("Error deleting NDIS plan:", error);
            });
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Handler to toggle the popup menu
  const togglePopupMenu = () => {
    setShowPopupMenu(!showPopupMenu);
    // Hide notification dot when menu is opened
    if (!showPopupMenu) {
      setShowNotificationDot(false);
    }
  };

  // Close popup menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        showPopupMenu && 
        menuRef.current && 
        !menuRef.current.contains(event.target as Node) &&
        dotsButtonRef.current &&
        !dotsButtonRef.current.contains(event.target as Node)
      ) {
        setShowPopupMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopupMenu]);

  // function to handle PII updates with modal feedback
  const handlePIIUpdate = (updatedPII: Array<[string, string]>, fileName: string) => {
    setShowPIIModal(false);
    
    // Show processing modal
    setModalVariant('loading');
    setModalMessage('Processing with updated information...');
    setShowUploadingModal(true);
    setUploadError(null);
    
    // Apply masking with the updated PII
    planUploadApi.applyMasking(processedText, updatedPII, documentVersion)
      .then(async (response: any) => {        
        // Extract masked text
        const responseData = response.data || response;
        const maskedText = responseData.masked_text;
        
        if (!maskedText || maskedText.trim().length === 0) {
          throw new Error("The PDF was processed but produced empty text");
        }
        
        const result = {
          originalFileName: pdfFile?.name || "document.pdf",
          sanitizedText: maskedText,
          piiCount: updatedPII.length,
          version: documentVersion
        };

        // Process with MongoDB
        setIsProcessingChunks(true);
        const s3Response = await planUploadApi.getPresignedUrl();
        const s3Url = s3Response.url;
        
        // Convert sanitized text to PDF
        const doc = new jsPDF();
        doc.text(result.sanitizedText, 10, 10);
        const pdfBlob = doc.output('blob');

        // Upload processed file to S3
        const s3 = axios.create({
          headers: { common: {} },
          transformRequest: (data) => data, 
        });
        
        try {
          // This will overwrite the raw plan
          await s3.put(
            s3Url,
            pdfBlob,
            {
              headers: {
                "Content-Type": "application/pdf"
              },
              validateStatus: () => true
            }
          );
          console.log(`file uploaded!`);
          setHasInjectedPdf(true);
        } catch (error: any) {
          console.error('Error uploading file:', error);
          console.log(`status: ${error.response?.status}`);
          console.log(`data: ${error.response?.data}`);
          if (error instanceof Error) {
            console.error('Error message:', error.message);
            console.error('Error stack:', error.stack);
          }
          throw error;
        }
      })
      .then(success => {
        // Send success message through websocket with file info
        const successMessage = `<div style="display: flex; align-items: flex-start; gap: 0.5em;"><img src="${planUploadedIcon}" alt="Plan uploaded" style="width: 1.5em; height: 1.5em; flex-shrink: 0; margin-top: 0.1em;" /><div style="text-align: left;"><div>Plan uploaded successfully</div><div style="color: #999999; font-size: 0.8em; margin-top: 0.25em;">${fileName}</div></div></div>`;
        onSend({ text: successMessage });
        
        // Show success modal
        setModalVariant('success');
        setModalMessage('PDF processed successfully!');
        // Keep the modal open for a moment to show success
        setTimeout(() => {
          setShowUploadingModal(false);
          // Now show the privacy modal after successful processing
          setShowModal(true);
          setConsentChecked(false);
        }, 2000);
        
        // Enable input and quick options
        setShowInput(true);
        setHasInjectedPdf(true);
        
        // Track successful PDF upload after PII verification
        trackPlanUploadSuccess(true);
      })
      .catch(error => {
        console.error("Error applying masking with updated PII:", error);
        
        // Set error modal
        let errorMessage = "Error processing with updated information. Please try again.";
        let errorType = 'updated_pii_error';
        
        if (error.message) {
          errorMessage = error.message;
        }
        
        setModalVariant('error');
        setModalMessage(errorMessage);
        setUploadError(errorMessage);
        
        // Track failed PDF upload with error type
        trackPlanUploadSuccess(false, errorType);
      })
      .finally(() => {
        // Make sure all processing states are reset
        setProcessingPdf(false);
        setIsProcessingChunks(false);
        setUpdatingPrompt(false);
      });
  };

  // Function to save the consent data to Supabase
  const saveConsentToSupabase = async () => {
    if (!user) {
      console.error("Cannot save consent: No user is logged in");
      toast.error("You must be logged in to save consent information");
      return;
    }
    
    // If the checkbox is not checked, we won't save anything
    if (!consentChecked) {
      setShowModal(false);
      return;
    }
    
    setSavingConsent(true);
    try {
      // First, get the current user data to preserve required fields
      const { data: existingUser, error: fetchError } = await supabaseClient
        .from("users")
        .select("*")
        .eq("id", user.id)
        .single();
      
      if (fetchError) {
        console.error("Error fetching existing user data:", fetchError);
        toast.error("Failed to retrieve your user information");
        return;
      }
      
      
      // Preserve all existing fields and update only what we need
      const updateData = {
        ...existingUser,
        ndis_plan_consent: consentChecked,
        ndis_plan_consent_updated_at: new Date().toISOString()
      };
      

      // Use update instead of upsert since we know the record exists
      const { data, error } = await supabaseClient
        .from("users")
        .update(updateData)
        .eq("id", user.id);

      if (error) {
        console.error("Error saving consent data:", error);
        toast.error("Failed to save consent information");
      } else {

        setHasExistingConsent(true);
      }
    } catch (err) {
      console.error("Unexpected error saving consent data:", err);
      toast.error("An unexpected error occurred");
    } finally {
      setSavingConsent(false);
      setShowModal(false);
    }
  };

  return (
    <>
      <section
        className="section-main"
        style={{ background: background, height: "100vh" }}
      >
        <div className=""></div>
        <HeaderPageBrad />
        <div
          className="d-flex flex-column align-items-center position-relative align-self-start"
          style={{
            width: "100%",
            maxWidth: 1440,
            height: isMobile ? "96dvh" : "100%",
            paddingBottom: (isMobile && isAndroid) ? "24px" : "0px",
          }}
        >
          <div className="w-100 flex-grow-1 overflow-auto">
            <Conversation
              chatUserConversations={
                messages.length > 0 ? messages : messageDefault
              }
            />
          </div>
          <div
            className="w-100 d-flex justify-content-center align-items-center gap-3 position-relative"
            style={{
              background:
              addTheme === "light"
                  ? "#F6F6F6"
                  : addTheme === "eclipse"
                  ? "#FFFFFF"
                  : "rgba(255, 255, 255, 0.1)",
              borderRadius: isMobile ? 30 : 60,
              padding: "15px 30px",
              maxWidth: "880px",
              border:
              addTheme === "eclipse" ? "1px solid #F6F6F6" : "none",
              marginBottom: (isMobile && isAndroid) ? "12px" : "0px",
            }}
          >
            
            <InputSection
              value={message}
              onChange={setMessage}
              onSubmit={onSubmit}
              disabled={
                (assistant && !assistant?.enabled) || 
                isReceivingMessage || 
                isProcessingChunks ||
                processingPdf ||
                updatingPrompt
              }
              selectedChat={selectedChat}
              selectedChatOption={selectedChatOption}
              quickOptions={quickOptions}
              handleQuickOptionClick={handleQuickOptionClick}
              showInput={showInput}
            />
            <div style={{ 
              display: 'flex', 
              alignItems: 'center',
              marginLeft: '5px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
          
               {/* Send / Stop button */}
                {isReceivingMessage ? (
                  <button
                    type="button"
                    onClick={onStop}
                    aria-label="Stop message"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      padding: 20,
                      margin: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      transition: 'background-color 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor =
                        addTheme === "dark"
                          ? 'rgba(255, 255, 255, 0.15)'
                          : (addTheme === "light" ? '#e0e0e0' : '#f0f0f0');
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <img 
                      src={closeIcon} 
                      alt="close" 
                      style={{ 
                        width: '20px', 
                        height: '20px',
                        filter: addTheme === "dark" 
                          ? "brightness(0) invert(1)" 
                          : "brightness(0)"
                      }} 
                    />
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={onSubmit}
                    disabled={isReceivingMessage || isProcessingChunks || !message.trim()}
                    aria-label="Send message"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      transition: 'background-color 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor =
                        addTheme === "dark"
                          ? 'rgba(255, 255, 255, 0.15)'
                          : (addTheme === "light" ? '#e0e0e0' : '#f0f0f0');
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <img
                      src={addTheme === "dark" ? sendButtonLight : sendButtonDark}
                      alt="Send"
                      style={{ 
                        width: '24px', 
                        height: '24px'
                      }}
                    />
                  </button>
                )}
                {/* 12px spacer */}
                <div style={{ width: '12px' }}></div>

                {/* Dots button */}
                <button
                  ref={dotsButtonRef}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePopupMenu();
                  }}
                  disabled={processingPdf || updatingPrompt || isProcessingChunks}
                  aria-label="More options"
                  style={{ 
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: processingPdf || updatingPrompt || isProcessingChunks ? 'default' : 'pointer',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    position: 'relative',
                    opacity: processingPdf || updatingPrompt || isProcessingChunks ? 0.5 : 1,
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    if (!processingPdf && !updatingPrompt && !isProcessingChunks) {
                      e.currentTarget.style.backgroundColor = addTheme === "dark" 
                        ? 'rgba(255, 255, 255, 0.15)' 
                        : (addTheme === "light" ? '#e0e0e0' : '#f0f0f0');
                    }
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  {/* Notification dot - only show if not clicked yet */}
                  {showNotificationDot && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: '#f9c550',
                        border: '1px solid white',
                        zIndex: 2
                      }}
                    />
                  )}
                  <img
                    src={dotsIcon}
                    alt="More options"
                    style={{ 
                      width: '24px', 
                      height: '24px',
                      filter: addTheme === "dark" 
                        ? "brightness(0) invert(1)" 
                        : "brightness(0)"
                    }}
                  />

                  {/* Popup Menu */}
                  {showPopupMenu && (
                    <div 
                      ref={menuRef} 
                      className="popup-menu" 
                      style={{ 
                        position: 'absolute',
                        bottom: isMobile ? '40px' : '30px',
                        right: isMobile ? '0' : 'auto',
                        left: isMobile ? 'auto' : '0',
                        width: isMobile ? '160px' : '140px',
                        backgroundColor: 'white',
                        borderRadius: '6px',
                        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        padding: '8px 0'
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {/* Upload Plan Option */}
                      <div 
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 12px',
                          cursor: isReceivingMessage || isProcessingChunks || processingPdf || updatingPrompt ? 'not-allowed' : 'pointer',
                          opacity: isReceivingMessage || isProcessingChunks || processingPdf || updatingPrompt ? 0.5 : 1
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label="Upload plan"
                        aria-disabled={isReceivingMessage || isProcessingChunks || processingPdf || updatingPrompt ? "true" : "false"}
                        onClick={(e) => {
                          if (isReceivingMessage || isProcessingChunks || processingPdf || updatingPrompt) {
                            e.stopPropagation();
                            return;
                          }
                          setShowPopupMenu(false);
                          
                          if (!user) {
                            navigate(WEB_LOGIN_PATH);
                            return;
                          }
                          
                          // Proceed with PDF upload if logged in
                          handlePdfButtonClick();
                        }}
                      >
                        <img
                          src={iconPdfDark}
                          alt="Upload PDF"
                          width="20"
                          height="20"
                          style={{ marginRight: '8px' }}
                        />
                        <span style={{ fontSize: '14px', fontWeight: 500, color: '#16140E' }}>Upload plan</span>
                      </div>
                      
                      {/* Voice Chat Option */}
                      <div 
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 12px',
                          cursor: 'not-allowed',
                          opacity: 0.5
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label="Voice chat"
                        aria-disabled="true"
                        onClick={(e) => {
                          e.stopPropagation();
                          // Voice chat functionality disabled
                        }}
                      >
                        <img
                          src={iconMicroDark}
                          alt="Voice Chat"
                          width="20"
                          height="20"
                          style={{ marginRight: '8px' }}
                        />
                        <span style={{ fontSize: '14px', fontWeight: 500, color: '#16140E' }}>Voice chat</span>
                      </div>
                    </div>
                  )}
                </button>
              </div>
              
              {/* Hidden file input for PDF upload */}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handlePdfUpload}
                accept="application/pdf"
                style={{ display: "none" }}
                disabled={processingPdf || updatingPrompt || isReceivingMessage || isProcessingChunks}
              />
            </div>
          </div>
        </div>
      </section>
      {showModal && <Modal 
        title="Keeping your sensitive information safe" 
        content={<>When you upload your plan, we <u>will not</u> store any of your personal information. If you are using a public computer, be sure to close your browser window at the end of your session.</>} 
        close={() => {
          setShowModal(false);
        }} 
        buttonText={savingConsent ? "Saving..." : "Okay"} 
        noLines={true}
        checkbox={!hasExistingConsent ? {
          text: "I am a support coordinator, informal support, or any person other than the NDIS participant, I warrant that I have obtained explicit consent from the NDIS participant to upload and use their plan information in FAM.",
          onChange: (checked) => setConsentChecked(checked),
          checked: consentChecked
        } : undefined}
        onButtonClick={saveConsentToSupabase}
      />}
      
      {/* Uploading modal with all variants */}
      {showUploadingModal && (
        <SimpleModal
          content={
            <p style={{ 
              margin: 0, 
              fontWeight: '500', 
              fontSize: '18px',
              lineHeight: '32px',
              color: '#16140E'
            }}>
              {modalMessage}
            </p>
          }
          close={() => {
            setShowUploadingModal(false);
            setUploadError(null);
          }}
          variant={modalVariant}
        />
      )}
      
      {/* Menu Modal replacing PIIVerificationModal */}
      <MenuModal
        isOpen={showPIIModal}
        onClose={() => {
          setShowPIIModal(false);
          setProcessingPdf(false);
        }}
        onSave={(data) => {
          handlePIIUpdate(data, pdfFileName);
        }}
        detectedPII={detectedPII}
      />
    </>
  );
}